import React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';


import Main from 'views/layouts/Main/Main';
import SimContainer from 'components/SimContainer';

import { Hero, Jobs, Newsletter } from './components';

const Careers = () => {
	const theme = useTheme();
	return (
		<Main>
			<Box background={theme.palette.background.default}>
				<Hero />
			</Box>

			<Box bgcolor={theme.palette.background.transparentDefault}>
				<SimContainer maxWidth={1000}>
					<Jobs />
				</SimContainer>

				<SimContainer paddingTop={'0 !important'}>
					<Newsletter />
				</SimContainer>

				<Box
					component={'svg'}
					preserveAspectRatio='none'
					xmlns='http://www.w3.org/2000/svg'
					x='0px'
					y='0px'
					viewBox='0 0 1920 100.1'
					sx={{
						marginBottom: -1,
						width: 1
					}}>
					<path fill={theme.palette.background.default} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
				</Box>
			</Box>
		</Main>
	);
};

export default Careers;
